import mapImg from '../../../assets/img/map.png'



export default function OnespaceSection() {
    return (
        <section 
            className='p-12 md:px-0 flex items-center flex-col bg-secondary2' 
        >

            <div 
                className="text-center leading-9 "
                
            >
                <h5 className="font-bold text-3xl text-primary md:mb-12">
                    Get it all in one space
                </h5>
                {/* <h5 className="font-bold text-3xl text-primary">
                    Manage your retail business from any part of the globe
                </h5> */}
                
            </div>

            <div className='w-10/12 flex md:flex-col justify-between items-center' >

                <div className="w-2/5 md:w-full my-8">
                    <h5 className="text-primary font-semibold text-2xl mb-8 md:mb-4" >
                        Manage your business anywhere from across the globe
                    </h5>
                    <p className="text-neutral-700 leading-6">
                        Access and manage your shop from your computer, laptop, tablet, or smartphone anytime you choose. Create access privileges so that your colleague or accountant can login and work with your data online.
                    </p>

                </div>
                
                <div className="w-2/5 md:w-full h-72 flex justify-center items-center">
                    <img src={mapImg} alt="manage multi locations" />
                </div>

                

            </div>
            
        </section>
    )
}
